import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'antd'
import styles from './index.scss'

const CodeModal = ({
  code,
  setVertifyCode,
  signUp,
  img,
  setImg
}) => {
  // code 输入框事件回调
  const codeChange = useCallback(event => setVertifyCode(event.target.value), [setVertifyCode])
  // 清空code输入框
  const close = useCallback(() => {
    setVertifyCode('')
    setImg('')
  }, [setVertifyCode, setImg])
  // 刷新二维码
  const refresh = useCallback(
    () => {
      setVertifyCode('')
      signUp()
    },
    [signUp, setVertifyCode]
  )
  // 回车提交
  const pressEnter = (e) => {
    if (e.keyCode !== 13) { return }
    signUp()
  }
  return (
    <Modal visible={!!img} onCancel={close} okText="立即报名" footer={null} centered bodyStyle={{ padding: '0px' }}>
      <div className={styles['r-partner-popup-wrap']}>
        <h2 className="title">请输入图形验证码</h2>
        <div className="content">
          <div className="twocode-wrap clearfix">
            <input type="text" className="code-input" maxLength="4" placeholder="输入验证码" value={code} onChange={codeChange} onKeyDown={pressEnter} />
            <div className="code-img js-codeimg" onClick={refresh}>
              <div className="img-container">
                { img && <img className="img" src={img} alt="加盟合伙人" /> }
              </div>
              <span className="refresh-icon" />
            </div>
          </div>
          <button type="button" className="submit-btn js-submit-btn" onClick={signUp}>立即报名</button>
        </div>
      </div>
    </Modal>
  )
}

CodeModal.propTypes = {
  code: PropTypes.string,
  img: PropTypes.string,
  setVertifyCode: PropTypes.func,
  signUp: PropTypes.func,
  setImg: PropTypes.func
}

CodeModal.defaultProps = {
  code: '',
  img: '',
  setVertifyCode: () => ({}),
  signUp: () => ({}),
  setImg: () => ({})
}

export default CodeModal
